import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { useLocation, useParams } from 'react-router';
import CreateBuyerSupplier from '../../components/buyerSupplier/CreateBuyerSupplier';
import CreateInterview from '../../components/interview/CreateInterview';
import CreateInterviewQuestionsSet from '../../components/interview/CreateInterviewQuestionsSet';
import LoginComponent from '../../components/common/LoginComponent';

const CreateInterviewQuestionSetPage: React.FC = () => {
  let orgPageTitle = 'Create Interview Qustions Set';
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{orgPageTitle}</IonTitle>
          <IonButtons slot='end'>
            <LoginComponent></LoginComponent>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar color="primary">
            <IonTitle size="large"> {orgPageTitle}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <CreateInterviewQuestionsSet></CreateInterviewQuestionsSet>
      </IonContent>
    </IonPage>
  );
};

export default CreateInterviewQuestionSetPage;
